import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { State } from '../../reducers/types.tsx';
import { getPersisted } from '../common/index.tsx';

export const getCreateAnalyticsEvent = (state: State): CreateUIAnalyticsEvent | undefined =>
	getPersisted(state).analytic.createAnalyticsEvent;
